import { render, staticRenderFns } from "./project-digital-human-selection.vue?vue&type=template&id=3786d2b8&scoped=true"
import script from "./project-digital-human-selection.vue?vue&type=script&lang=js"
export * from "./project-digital-human-selection.vue?vue&type=script&lang=js"
import style0 from "./project-digital-human-selection.vue?vue&type=style&index=0&id=3786d2b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\wwwroot\\deepcityAI\\user-client-pc\\user-client-common-pc\\node_modules\\@vue\\vue-loader-v15\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3786d2b8",
  null
  
)

export default component.exports